export enum PaymentProviderType {
  Nets = 0,
  Swish = 1,
  Neonomics = 2,
}
